import { DataSourceDetails } from "Hooks/Api/apiBusinessNumber";
import { useBusinessNumberDescription } from "Hooks/ApiContext/BusinessNumberDesciptionContext";
import { store } from "Models/Store";
import { EntityItem, EntityItemSection } from "../EntityItemSection/EntityItemSection";

export function AcnEntityItemSection(props: {
	status?: string | null,
	entityTypeCode?: string | null,
	entityName?: string | null,
	source?: DataSourceDetails,
	fallbackValue: string
}) {
	const { data } = useBusinessNumberDescription();

	const { status, entityTypeCode, entityName, source, fallbackValue } = props;
	const formatValue = (value?: string | null) => value?.trim() ? value : fallbackValue;

	const item: EntityItem = {
		status: status && data
			? data.mapAcnEntityStatusToDescription[status] ?? fallbackValue
			: fallbackValue,

		type: entityTypeCode && data
			? data.mapAcnEntityCodeToDescription[entityTypeCode] ?? fallbackValue
			: fallbackValue,

		entityName: formatValue(entityName),
		source: source,
		fallbackValue: fallbackValue,
	}

	return (
		<EntityItemSection>
			<div style={{ display: "flex", flexDirection: "row" }}>
				<div style={{ display: "flex", flexDirection: "column" }}>
					<EntityItemSection.Status item={item} />
					<EntityItemSection.Type item={item} />
					<EntityItemSection.EntityName item={item} />
				</div>
				{/* Only for super user to investigate isssues */}
				{store.userType === 'SUPER_USER' && item.source?.type !== 'Live' && (
					<EntityItemSection.Source item={item} />
				)}
			</div>
		</EntityItemSection>
	)
}